import { render, staticRenderFns } from "./ProceduresSearchBar.vue?vue&type=template&id=1a46c68a&scoped=true"
import script from "./ProceduresSearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProceduresSearchBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProceduresSearchBar.vue?vue&type=style&index=0&id=1a46c68a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a46c68a",
  null
  
)

export default component.exports